// @flow
import { getLogger } from "@cld/upload-widget";
import { selectClientUploadsBatch } from "../store/selectors";
import { EVENT_TYPES } from "../common/events";
import { types as ats } from "../store/actions";

const logger = getLogger();

const processClientUploadsBatch = (newState: Object, prevState: Object, uploader, actions) => {
	const uploadsBatch = selectClientUploadsBatch(newState);
	const prevUploadsBatch = selectClientUploadsBatch(prevState);

	if (uploadsBatch && (
		// new batch
		!prevUploadsBatch ||
		// not the same batch
		uploadsBatch.id !== prevUploadsBatch.id ||
		// files in batch changed
		uploadsBatch.files.length !== prevUploadsBatch.files.length)) {

		logger.log(`[uploader.stateProcessors]: client uploads batch changed, new batch (${uploadsBatch.id}) has ${uploadsBatch.files.length} files`);

		if (uploadsBatch.files.length <= 1 && uploadsBatch.count > 1) { // new batch - need to simulate queue start
			uploader.emit(EVENT_TYPES.UPLOADER_BATCH_STARTED);

			uploader.emit(EVENT_TYPES.UPLOADER_FILE_STATUS, {
				ids: [],
				files: {},
				simulated: true,
			});
		} else if (uploadsBatch.files.length > 0 && uploadsBatch.files.length === uploadsBatch.count) { // batch full - need to start uploading !
			if (uploadsBatch.batchOptions?.publicId) {
				//ext files came with publicId value
				uploader.setUploadPublicId(uploadsBatch.batchOptions.publicId, true);
			}

			actions[ats.CLEAR_UPLOADER_CLIENT_BATCH]();

			logger.log(`[uploader.stateProcessors]: adding client uploads batch (${uploadsBatch.id}) to queue`);

			uploader.addToQueue({
				files: uploadsBatch.files,
				batchOptions: uploadsBatch.batchOptions,
				cropInfo: uploadsBatch.cropInfo ? uploadsBatch.cropInfo : [],
				config: uploadsBatch.config, // the folder that was set when the batch was created
			});
		}
	}
};

export default processClientUploadsBatch;
